var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconEncryptionOutbound = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 5.7H12.2C12.9 5.7 13.5 6.3 13.5 7V13.7C13.5 14.4 12.9 15 12.2 15H8.20005H6.30005V14H8.20005V12.6C7.80005 12.6 7.40005 12.5 7.00005 12.3L7.50005 11.4C7.70005 11.5 8.00005 11.6 8.20005 11.6C8.90005 11.6 9.50005 11 9.50005 10.3C9.50005 9.6 8.90005 9 8.20005 9C7.90005 9 7.70005 9.1 7.50005 9.2L7.00005 8.4C7.30005 8.1 7.70005 8 8.20005 8V6.6H6.40005V5.6H8.40005H9.40005H9.80005H10.1V4.3C10.1 3.2 9.20005 2.3 8.10005 2.3V2.2C7.90005 2.2 7.60005 2.3 7.40005 2.4L6.90005 1.3C7.30005 1.1 7.70005 1 8.20005 1C10 1 11.5 2.5 11.5 4.3V5.7ZM7.0999 9.70001C6.9999 9.90001 6.8999 10.1 6.8999 10.3C6.8999 10.6 6.8999 10.8 6.9999 11L6.1999 11.4C5.9999 11.1 5.8999 10.7 5.8999 10.3C5.8999 9.90001 5.9999 9.60001 6.1999 9.20001L7.0999 9.70001ZM6.50005 4.59998H5.30005V5.59998H4.69995C4.09995 5.59998 3.49995 5.99998 3.19995 6.49998L4.09995 6.99998C4.19995 6.79998 4.49995 6.59998 4.69995 6.59998H5.39995V5.59998H6.50005V4.59998ZM6.10005 1.90002L7.00005 2.80002C6.70005 3.00002 6.50005 3.40002 6.50005 3.90002L5.30005 3.80002C5.30005 3.10002 5.60005 2.40002 6.10005 1.90002ZM4 7.79999H3V9.79999H4V7.79999ZM3 10.8H4V12.8H3V10.8ZM3.1001 14L4.0001 13.6C4.2001 13.8 4.4001 14 4.7001 14H5.3001V15H4.7001C4.0001 15 3.4001 14.6 3.1001 14Z",
    fill: "#AFAFAE"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconEncryptionOutbound);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_encryption_outbound.244f1333a798dab471d00878f7694909.svg";